export function timeFromPercentage(duration: number, percentage: number) {
  const newTime = (percentage * duration) / 100;
  return Math.round(newTime);
}

export function progressPercentageFromDuration(
  currentTime: number,
  duration: number,
) {
  return (currentTime / duration) * 100;
}

export function progressPercentageFromHTMLWidth(
  elem: HTMLElement,
  position: number,
) {
  const progressBarRectangle = elem.getBoundingClientRect();
  return (
    ((position - progressBarRectangle.x) / progressBarRectangle.width) * 100
  );
}

export function formatSeconds(seconds: number) {
  const minutes = Math.floor(seconds / 60);
  const secondsLeft = Math.floor(seconds % 60);
  const secondsLeftFormatted =
    secondsLeft < 10 ? `0${secondsLeft}` : secondsLeft;
  return `${minutes}:${secondsLeftFormatted}`;
}
